import { Header } from 'components/molecules';
import { ChangePasswordTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const ChangePasswordPage = () => {
  return (
    <>
      <Header
        title="Cambia tu contraseña"
        subtitle="Si deseas cambiar tu contraseña, acá te podemos ayudar"
      />
      <ChangePasswordTemplate />
    </>
  );
};

export default withAuth(ChangePasswordPage);
